import * as React from 'react';
import { FieldLabel } from 'features/DigitalMarketing/components/FormControls';
import {
  editWebsiteContentInputClassName,
  editWebsiteContentLabelClassName,
  profileFormInputClassName,
  profileFormLabelClassName,
  profileFormErrorClassName,
} from 'features/DigitalMarketing/constants/formStyles';
import { DMDiv, DMInput, DMText } from '../Primitives';

// ---------- Edit Website Content styled variant ----------

type DMFormFieldProps = {
  label: string;
  name: string;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  icon?: React.ReactNode;
  required?: boolean;
  inputMode?: 'text' | 'numeric' | 'email' | 'tel';
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
};

export const DMFormField = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  type = 'text',
  icon,
  required = false,
  inputMode,
  className = '',
  inputClassName,
  labelClassName,
}: DMFormFieldProps) => (
  <DMDiv className={className}>
    <FieldLabel
      className={labelClassName || editWebsiteContentLabelClassName}
      required={required}
    >
      {label}
    </FieldLabel>
    <DMDiv className="relative">
      <DMInput
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        inputMode={inputMode}
        className={`${inputClassName || editWebsiteContentInputClassName} ${
          icon ? 'pr-[3vw]' : ''
        }`}
      />
      {icon && (
        <DMDiv className="pointer-events-none absolute right-[1vw] top-1/2 -translate-y-1/2 text-black">
          {icon}
        </DMDiv>
      )}
    </DMDiv>
  </DMDiv>
);

// ---------- Profile Form styled variant ----------

type DMProfileFormFieldProps = {
  label: string;
  name: string;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  required?: boolean;
  inputMode?: 'text' | 'numeric' | 'email' | 'tel';
  error?: string;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  errorClassName?: string;
};

export const DMProfileFormField = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  type = 'text',
  required = false,
  inputMode,
  error,
  className = '',
  inputClassName,
  labelClassName,
  errorClassName,
}: DMProfileFormFieldProps) => (
  <DMDiv className={className}>
    <FieldLabel
      className={labelClassName || profileFormLabelClassName}
      required={required}
    >
      {label}
    </FieldLabel>
    <DMInput
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      inputMode={inputMode}
      className={inputClassName || profileFormInputClassName}
    />
    {error && (
      <DMText className={errorClassName || profileFormErrorClassName}>
        {error}
      </DMText>
    )}
  </DMDiv>
);
